import {Pipe, PipeTransform} from '@angular/core';
import {RtDefineStrokeWidthService} from '../../rt-define-stroke-width/rt-define-stroke-width.service';
import {CSSFont} from '../../rt-define-stroke-width/symbols';

@Pipe({ name: 'defineCarouselItemWidth' })
export class DefineCarouselItemWidthPipe implements PipeTransform {
  /** Contain additional width to cover border, padding, etc. */
  private readonly widthOffset = 40;

  constructor(private defineStrokeWidth: RtDefineStrokeWidthService) {
  }

  transform(name: string, fontRule: CSSFont): number {
    return this.defineStrokeWidth.getTextWidth(name, fontRule) + this.widthOffset;
  }
}
